import { pushClient } from '@/services/push';
import { dispatch } from 'nike-re-framejs';

const scoreboardPushSubscription = pushClient.subscription({
    onMessage(message) {
        dispatch(['scoreboards.applyMessage', message]);
    },
    onSnapshot(snapshots) {
        const events = snapshots.filter(s => s.match);
        dispatch(['scoreboards.storeEvents', events]);
    }
});

export function scoreboardResetPaths(denormalizedMatchIds) {
    const paths = denormalizedMatchIds
        .toSet()
        .map(id => ['/n1/match/' + id + '/scoreboard/'])
        .toArray();
    scoreboardPushSubscription.resetPaths(paths);
}
